const isUat = window.location.href.includes('uat');
const isPre = window.location.href.includes('pre');

export const getPrefix = () => {
    if (isUat) {
        return 'uat-';
    }
    if (isPre) {
        return 'pre-';
    }
    return '';
};
export const gfOrigin = `https://${getPrefix()}gf.bilibili.com`;

export const mallOrigin = import.meta.env.MODE === 'development' ? '' : `https://${getPrefix()}mall.bilibili.com`;

export const cmOrigin = `https://${getPrefix()}cm.bilibili.com`;

// 来源类型
export const SOURCE_TYPE = {
    // 商家
    SHOP: 'shop',
    // 工房
    GF: 'gf',
    // 悬赏
    AWARD: 'award'
};

export const DEFAULT_SOURCE_FROM = 'pc_sj';

// 鉴权请求头key
export const AUTH_KEY = 'sourceKey';

export const ERROR_CODE_MAP = {
    NO_AUTH: 83001004, // 无权限
    NO_BUSINESS_ACCOUNT: 83001005, // 无经营账号
    TEXT_CHECK_ERROR: 71100001
};

// 根据source_type取对应配置，没source__type取商家配置
export const SOURCE_CONFIG = {
    [SOURCE_TYPE.SHOP]: {
        // 视图用配置
        color: '#4568FA', // 主题色
        buttonRound: false, // 按钮圆形

        // 逻辑用配置
        isShowAddStore: false, // 是否显示添加带货商品
        [AUTH_KEY]: 'mall-store', // 系统key，鉴权用，放在请求头里
        errorUrl: {
            // 无权限跳转链接
            [ERROR_CODE_MAP.NO_AUTH]: '',
            [ERROR_CODE_MAP.NO_BUSINESS_ACCOUNT]: '/db/home'
        },
        targetOrigin: null
    },
    [SOURCE_TYPE.GF]: {
        // 视图用配置
        color: '#FF6699', // 主题色
        buttonRound: true, // 按钮圆形

        // 逻辑用配置
        isShowAddStore: false, // 是否显示添加带货商品
        [AUTH_KEY]: 'mall-workshop', // 系统key，鉴权用，放在请求头里
        errorUrl: {
            // 无权限跳转链接
            [ERROR_CODE_MAP.NO_AUTH]: '/newCertificate'
        },
        targetOrigin: gfOrigin
    },
    [SOURCE_TYPE.AWARD]: {
        // 视图用配置
        color: '#00AEEC', // 主题色
        buttonRound: true, // 按钮圆形

        // 逻辑用配置
        isShowAddStore: true, // 是否显示添加带货商品
        [AUTH_KEY]: 'mall-up', // 系统key，鉴权用，放在请求头里
        errorUrl: {},
        targetOrigin: cmOrigin
    }
};

export const SMALL_SHOP_H5 =
    'https://mall.bilibili.com/neul-next/detailshop/index.html?page=detailshop_detail&noTitleBar=1';

export const EXAMPLE_IMG = [
    {
        title: '小店入口',
        url: '//i0.hdslb.com/bfs/kfptfe/floor/53075453825fee2112afaf5f61aaa5b143040bdc.png'
    },
    {
        title: '简介和账号身份标签',
        url: '//i0.hdslb.com/bfs/kfptfe/floor/6024d0244e22390d10ef31ea0bae315e2702da0a.png'
    }
];

export const SCENE_MAP = {
    SMALL_SHOP: {
        sceneId: 0,
        scene: '小店'
    },
    GF: {
        sceneId: 1,
        scene: '工房'
    },
    REWARD: {
        sceneId: 2,
        scene: '悬赏'
    }
};

export const GOODS_TYPE = {
    /** 0 普通商品
        1 闪购商品
        2 商家一番赏商品
        3 魔力赏
        4 一番赏
        5 磁力赏
        100 红包商品
        101 国补会场
    */
    NORMAL: 0,
    FLASH: 1,
    ONE_PIECE: 2,
    MAGIC: 3,
    ONE_PIECE_2: 4,
    MAGNETIC: 5,
    RED_PACKET: 100,
    NATIONAL_SUPPLEMENT: 101
};
